import $ from 'jquery';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';

$(function () {

    $('.scrollingcards .swiper').each(function (tc, i) {
        const $this = $(this);
        new Swiper(this, {
            modules: [Navigation],
            navigation: {
                nextEl: '.next',
                prevEl: '.prev'
            },
            direction: 'horizontal',
            loop: false,
            slidesPerView: 1,
            spaceBetween: 8,
            breakpoints: {
                799: {
                    slidesPerView: 3,
                    spaceBetween: 24
                },
                999: {
                    slidesPerView: 4,
                    spaceBetween: 24
                }
            }
        });
    });
});
